import { AxiosResponse } from "axios";
import Access from "../interface/Access";

const AccessDTO = {
  convertAccessResponse: (response: AxiosResponse): Access => {
    if (response.data) {
      return {
        ...response.data,
      };
    }
    return {} as Access;
  },
};
export default AccessDTO;
